import React, { useMemo } from 'react';
import Grid from '@mui/material/Grid';
import { NavLink } from '../../NavLink';
import { styled } from '@mui/material/styles';
import { jsx as _jsx } from "react/jsx-runtime";
export function FooterLinks(props) {
  var links = props.links;
  var footerLinkNavItem = function footerLinkNavItem(link) {
    var _link$linkUrl, _link$linkUrl2;
    var navItem = {
      key: link.name,
      label: link.linkText ? link.linkText : link.name
    };
    if (link.linkType === 'Footer Icon') {
      navItem.content = /*#__PURE__*/_jsx(StyledImage, {
        alt: link.linkText,
        src: link.iconImage
      });
      switch (link.iconValueType) {
        case 'Email':
          navItem.url = "mailto:".concat(link.email);
          break;
        case 'Mobile':
          navItem.url = "tel:".concat(link.mobile);
          break;
        default:
          if (!link.openInNewWindow && (_link$linkUrl = link.linkUrl) != null && _link$linkUrl.includes('/cep/app/')) {
            navItem.route = link.linkUrl.replace('/cep/app/', '/');
          } else {
            navItem.url = link.linkUrl;
          }
      }
    } else if (!link.openInNewWindow && (_link$linkUrl2 = link.linkUrl) != null && _link$linkUrl2.includes('/cep/app/')) {
      navItem.route = link.linkUrl.replace('/cep/app/', '/');
    } else {
      navItem.url = link.linkUrl;
    }
    if (link.linkType === 'Footer Text') {
      navItem.url = '';
    }
    return navItem;
  };
  var navItems = useMemo(function () {
    return links ? links.map(function (link) {
      return footerLinkNavItem(link);
    }) : [];
  }, [links]);
  return /*#__PURE__*/_jsx(Grid, {
    container: true,
    marginTop: 4,
    "data-element": "Grid",
    "data-component": "FooterLinks",
    "data-source-file": "FooterLinks.tsx",
    children: navItems.map(function (navItem) {
      return /*#__PURE__*/_jsx(Grid, {
        item: true,
        sx: {
          fontSize: '14px',
          marginBottom: '32px',
          pointerEvents: navItem.url === '' ? 'none' : 'auto'
        },
        xs: navItem.url === '' ? 10 : 6,
        children: /*#__PURE__*/_jsx(NavLink, {
          "data-testid": "".concat(navItem.key),
          navItem: navItem
        })
      }, navItem.key);
    })
  });
}
var StyledImage = styled('img')(function (_ref) {
  var theme = _ref.theme;
  return {
    maxHeight: '24px',
    maxWidth: '24px'
  };
});